import React from "react";
import buttonIcon from '../img/button-icon-sb.png'


export const UiButtonIcon = () => {
    return (
        <>
            <img src={buttonIcon} />
        </>
    )

}